import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';
import { affirprice, formatCurrency } from '../../helpers/utils';


declare const window: any
const GroupCardProductSale = (props: any) => {

  const optionalproduct = (optionalproduct: any) => {
    let items: any = []
    optionalproduct?.map((productitems: any, i: number) => {
      items.push(productitems.product.displayTitle)
      return items.push(" or ")
    })
    items.pop()
    return items;
  }

  useEffect(() => {
    if (window.affirm && window.affirm.ui) {
      try {
        window.affirm.ui.refresh();
      } catch (err) {
      }
    }

  })


  const strickoutcheck = (item: any) => {
    let pricenew: any = null;
    let priceval = item.price - item.newPrice;
    if (priceval != null) {
      pricenew = priceval.toFixed(2)
    }

    if (item.newPrice === null) {
      return (
        <h3 className="cardproduct-h3-style">
          <span
            className="cardproduct-h3-strick"
          >


          </span>
          <span className="cardproduct-h3-style-no-discount">{props.productdetail.currency.symbol}{formatCurrency(item.price)}</span>
        </h3>

      )

    } else {
      return (
        <React.Fragment>
          <h3 className="cardproduct-h3-style">
            <span
              className="cardproduct-h3-strick"
            >

              {props.productdetail.currency.symbol}{item.price}
            </span>
            <span className="cardproduct-h3-style-price">{props.productdetail.currency.symbol}{formatCurrency(item.newPrice)}</span>
          </h3>
          <h6 className="card-product-you-save"> You Save <strong> {props.productdetail.currency.symbol}{formatCurrency(pricenew)}</strong>!</h6>
        </React.Fragment>
      )
    }

  }
  return (
    <>
    <div className="free-shipping-bundles">
        Free Shipping on all Cross Body Trainer Packages!
      </div>
    <div className="GroupCardProductSale">
      <div className="GroupCardProductSale-felxbox">
        <h2 className="GroupCardProductSale-h2">{props.data.title}</h2>
        <h6 className="GroupCardProductSale-h6">
          {props.data.description}
        </h6>
      </div>

      <div className="CardProductSale-container">
        <div className="container">
          <Row xl={3} sm={1} xs={1} md={2}>
            {props.productdetail?.product_bundles.map((item: any, i: number) => {
              return (
                <Col key={i} className="CardProductSale-Container">
                  <div className="app-card ">
                    <div className="CardProductSale-flexbox-content">
                      <div>
                        <img
                          className="CardProductSale-img"
                          src={API.baseUrl + item.image[0]?.url}
                          alt={item.title}
                        />
                      </div>

                      <div className="CardProductSale-h5">
                        <h5>{item.title}</h5>
                      </div>
                      <div className="CardProductSale-price-card">
                        {strickoutcheck(item)}
                      </div>
                      <div>
                        <h6>
                          <button
                            onClick={() => { props.onCloseHandler(item) }}
                            // href="?add-to-cart=10380"
                            className="cardproduct-button"
                          >
                            {props.data.buyNowButtonLable}
                          </button>
                        </h6>
                      </div>
                      <div className="CardProductSale-affirm">
                        <p className="affirm-as-low-as" data-page-type="category" data-amount={item.newPrice === null ? affirprice(item.price) : affirprice(item.newPrice)} ></p>
                      </div>
                      <div>
                        <h6 className="cardproduc-tooltip-h6-center">
                          <span className="cardproduc-tooltip-h6">{item.Info.label}</span>{' '}
                          <span className="tooltips">
                            i
                            <span className="tooltiptexts" dangerouslySetInnerHTML={{ __html: item.Info.description }}>

                            </span>
                          </span>
                        </h6>
                      </div>
                    </div>
                    <div className="CardProducctSale-flexbox2-include">
                      <div>
                        <h6
                          className="cardproductsale-text-include"
                        >
                          Includes
                        </h6>
                      </div>
                      <div>
                        {item.Includes.map((items: any, i: number) => {
                          if (items.__component === "info.info-component") {
                            return (<h6 className="CardProductSale-include-h6" key={i}>
                              {items.label}{" "}
                              <span className="tooltips">
                                i
                                <span className="tooltiptexts" dangerouslySetInnerHTML={{ __html: items.description }}>

                                </span>
                              </span>
                            </h6>)
                          }
                          return (<h6 key={i} className="CardProductSale-include-h6">{items.product?.title != null ? items.product?.title : optionalproduct(items.OptionalProducts)} {items.quantity != null ? "(" + items.quantity + ")" : null}</h6>)
                        })}


                      </div>
                    </div>

                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
</>
  );
};

export default GroupCardProductSale;
